'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.loadUserActivityData = loadUserActivityData;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var USER_ACTIVITY_LOAD = 'ms/activity/user_load';
var USER_ACTIVITY_LOAD_SUCCESS = 'ms/activity/user_load_success';
var USER_ACTIVITY_LOAD_FAIL = 'ms/activity/user_load_fail';

var USER_ACTIVITY_APPEND = 'ms/activity/user_activity_append';
var USER_ACTIVITY_APPEND_SUCCESS = 'ms/activity/user_activity_append_success';
var USER_ACTIVITY_APPEND_FAIL = 'ms/activity/user_activity_append_fail';

var initialState = {
  currentPage: 1,
  pages: 0,
  userActivities: []
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case USER_ACTIVITY_LOAD:
      return (0, _extends3.default)({}, state, {
        loadingActivity: true,
        loadingActivityError: null
      });

    case USER_ACTIVITY_LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        userActivities: action.result.activities || [],
        pages: action.result.pages,
        loadingActivity: false,
        loadingActivityError: null
      });

    case USER_ACTIVITY_LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingActivity: false,
        loadingActivityError: action.error
      });

    case USER_ACTIVITY_APPEND:
      return (0, _extends3.default)({}, state, {
        loadingActivity: true,
        loadingActivityError: null
      });

    case USER_ACTIVITY_APPEND_SUCCESS:
      return (0, _extends3.default)({}, state, {
        userActivities: state.userActivities.concat(action.result.activities),
        pages: action.result.pages,
        currentPage: state.currentPage + 1,
        loadingActivity: false,
        loadingActivityError: null
      });

    case USER_ACTIVITY_APPEND_FAIL:
      return (0, _extends3.default)({}, state, {
        loadingActivity: false,
        loadingActivityError: action.error
      });

    default:
      return state;
  }
}

// Action creators
function loadUserActivityData() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
  var append = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var limit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 20;

  return function (dispatch) {
    return dispatch({
      types: append ? [USER_ACTIVITY_APPEND, USER_ACTIVITY_APPEND_SUCCESS, USER_ACTIVITY_APPEND_FAIL] : [USER_ACTIVITY_LOAD, USER_ACTIVITY_LOAD_SUCCESS, USER_ACTIVITY_LOAD_FAIL],
      promise: loadActivities(page, limit)
    });
  };
}

// Private
function loadActivities(page, limit) {
  var query = 'page=' + page + '&limit=' + limit;

  return function (client) {
    var loadingPromise = client.get('v1/users/activity/self?' + query).then(function (result) {
      return {
        activities: result.activities || [],
        pages: result.pages || 0
      };
    });

    return loadingPromise;
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/activity.js
// module id = 598
// module chunks = 0